import {modules} from '../../pages/Home/Remotes/RemoteCards'

export const handleDirectAccess = () => {
  const isDirectAccess = !document.referrer && window.location.pathname !== '/'
  const protectedPaths = modules.map((m) => m.path)

  if (
    isDirectAccess &&
    protectedPaths.some((basePath) =>
      window.location.pathname.startsWith(basePath),
    )
  ) {
    window.location.href = '/'
  }
}
